export enum AFTER_SIGN_IN_ACTION_TYPES {
  TOGGLE_BET_BUILDER_MODAL = 'toggleBetBuilderModal',
  BOOKING_BET_GET_EVENT_ID = 'bookingBetGetEventId',
  NAVIGATE_TO_MY_CASINO = 'navigateToMyCasino',
  SUBSCRIBE_FOR_NOTIFICATION = 'subscribeForNotifications',
  OPT_IN_ACTION = 'optInAction',
  OPEN_CASINO_GAME = 'openCasinoGame',
  CONSTRUCT_CASINO_VIEW_URL = 'constructCasinoViewUrl',
  RECONSTRUCT_CASINO_VIEW_URL = 'reconstructCasinoViewUrl',
  RACING_BET_MODAL = 'racingBetModal',
  OPEN_FAVORITE_TEAM_POPUP = 'openFavoriteTeamPopup',
  OPEN_SINGLE_GAME_FROM_MINIMIZED_STREAMING = 'openSingleGameFromMinimizedStreaming'
}

export type TAfterSignInActions = {
  openBetBuilderAction?: string;
};

export class AfterSignIn {
  static _instance: AfterSignIn;
  static actions: Record<string, () => Promise<unknown>> = {};
  static afterExecutionCallback: () => void;
  static finalExecutionCallback: () => void;

  constructor() {
    if (AfterSignIn._instance) {
      return AfterSignIn._instance;
    }

    AfterSignIn._instance = this;
  }

  setAfterExecutionCallback = (callback: () => void) => {
    AfterSignIn.afterExecutionCallback = callback;
  };

  setFinalExecutionCallback = (callback: () => void) => {
    AfterSignIn.finalExecutionCallback = callback;
  };

  appendAction = (key: string, promise: () => Promise<any>) => {
    AfterSignIn.actions[key] = promise;
  };

  isActionsExist = () => {
    return !!Object.values(AfterSignIn.actions).length;
  };

  removeActions = () => {
    AfterSignIn.actions = {};
  };

  executeActions = () => {
    const successAction = () => {
      return new Promise(resolve => {
        resolve(true);
      });
    };

    Promise.all(
      [...Object.values(AfterSignIn.actions), successAction].map(func => func())
    ).then(() => {
      AfterSignIn.actions = {};

      AfterSignIn.afterExecutionCallback &&
        AfterSignIn.afterExecutionCallback();

      AfterSignIn.finalExecutionCallback &&
        AfterSignIn.finalExecutionCallback();
    });
  };
}
